import React, { useRef, useState } from "react";
import { MapContainer, TileLayer, Marker, Popup, useMap } from "react-leaflet";
import SearchBar from "../general/searchBar.jsx";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

// Fix pour les icônes de marqueur
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl:
    "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png",
  iconUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png",
  shadowUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png",
});

// Composant interne pour recentrer la carte
const FlyToLocation = ({ position }) => {
  const map = useMap();
  map.flyTo(position, 13);
  return null;
};

const AgencyMap = () => {
  const agencies = [
    {
      name: "Agileom Amiens",
      address: "56 rue du Vivier 80000 Amiens",
      phone: "03 74 47 89 90",
      position: [49.895, 2.302],
    },
    {
      name: "Agileom Marseille",
      address: "10 rue Paradis 13001 Marseille",
      phone: "04 91 99 00 00",
      position: [43.2965, 5.3698],
    },
    {
      name: "Agileom Nice",
      address: "22 Promenade des Anglais 06000 Nice",
      phone: "04 93 12 34 56",
      position: [43.6955, 7.2655],
    },
  ];

  const [selectedPosition, setSelectedPosition] = useState(
    agencies[0].position
  );

  return (
    <section className="agency-map-section">
      <SearchBar />
      <div className="agency-map-container" style={{ display: "flex" }}>
        <div className="agency-list" style={{ width: "30%", padding: "1rem" }}>
          <h3 className="agency-list-title">Nos agences</h3>
          <ul className="agency-cards">
            {agencies.map((agency, index) => (
              <li
                key={index}
                className="agency-card"
                onClick={() => setSelectedPosition(agency.position)}
                style={{ cursor: "pointer", marginBottom: "1rem" }}
              >
                <h4>{agency.name}</h4>
                <p>
                  <i className="fa-solid fa-map-pin"></i> {agency.address}
                </p>
                <p>
                  <i className="fa-solid fa-phone"></i> {agency.phone}
                </p>
              </li>
            ))}
          </ul>
        </div>
        <div className="agency-map" style={{ width: "70%", height: "500px" }}>
          <MapContainer
            center={selectedPosition}
            zoom={13}
            scrollWheelZoom={false}
            style={{ height: "100%", width: "100%" }}
          >
            <TileLayer
              attribution='&copy; <a href="https://carto.com/">CartoDB</a>'
              url="https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png"
            />

            <FlyToLocation position={selectedPosition} />
            {agencies.map((agency, i) => (
              <Marker key={i} position={agency.position}>
                <Popup>
                  <strong>{agency.name}</strong>
                  <br />
                  {agency.address}
                  <br />
                  {agency.phone}
                </Popup>
              </Marker>
            ))}
          </MapContainer>
        </div>
      </div>
    </section>
  );
};

export default AgencyMap;
